// 常见问题数据（FAQ）

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "全网吃瓜的内容从哪里来？",
    a: "我们汇集的是各公开平台上围绕热门话题的网友真实讨论片段，并对其进行聚合与归类整理。所有观点均标注为「网友声音」，仅作信息聚合展示，不代表本平台立场。",
  },
  {
    q: "「舆论风向」是怎么算出来的？",
    a: "我们会结合公开讨论中表态的正向、中性与负向占比，以及高频情绪关键词与高赞评论，人工归纳出主流态度的倾向性概览，方便你快速抓住「大家怎么看」。",
  },
  {
    q: "看到的观点会不会有偏颇？",
    a: "我们会尽量覆盖持不同立场的代表性声音，并在每个话题下并列展示「支持 / 中立 / 反对」等多方观点，尽量避免只呈现单一立场，帮助你形成更全面的判断。",
  },
  {
    q: "我可以参与话题讨论或投稿吗？",
    a: "当然可以。你可以在话题详情页对态度进行表态投票，也可以把身边热议、希望被汇总的讨论话题通过联系我们告知我们，经核实整理后会纳入更新。",
  },
  {
    q: "网站会搬运或转发未经证实的信息吗？",
    a: "不会。我们只聚合讨论本身，不对未经证实的事实作结论性传播；涉及事实争议的话题，我们会明确提示「信源待核」，引导理性看待。",
  },
  {
    q: "需要付费或注册才能使用吗？",
    a: "目前所有榜单、观点速览与话题汇总都免费开放，无需注册即可浏览，我们尽量做到打开即用。",
  },
];

// 口碑金句（吃瓜群众语录 / 网站口碑）

export interface QuoteItem {
  text: string;
  author: string;
  role: string;
}

export const quotes: QuoteItem[] = [
  {
    text: "以前追热点要刷十几个平台翻评论，现在一个页面就能看懂大家态度，太省心了。",
    author: "山高我为峰",
    role: "上班族 · 订阅读者",
  },
  {
    text: "最喜欢的是它把支持/中立/反对都摆出来，不藏着掖着，看得见两边在吵什么。",
    author: "糖炒栗子",
    role: "数码爱好者",
  },
  {
    text: "通勤路上刷两篇「舆论速览」，到公司正好能跟同事对上聊天话题，很实用。",
    author: "三号线通勤人",
    role: "都市白领",
  },
  {
    text: "作为内容创作者，它给了我很多讨论选题的灵感，风向抓得挺准。",
    author: "半糖不加冰",
    role: "自媒体作者",
  },
  {
    text: "态度投票这个小互动很戳我，原来我不是一个人这么想。",
    author: "深夜话痨",
    role: "大学生",
  },
];

// 关于页 - 品牌理念条目

export interface ValueItem {
  icon: string;
  title: string;
  desc: string;
}

export const brandValues: ValueItem[] = [
  {
    icon: "ri-eye-line",
    title: "看得见的多元",
    desc: "坚持并列呈现支持、中立、反对等不同声音，避免把舆论简化成单一答案。",
  },
  {
    icon: "ri-focus-3-line",
    title: "抓得住的重点",
    desc: "用结构化速览浓缩信息，让你用一分钟抓住热门话题的讨论主线与情绪走向。",
  },
  {
    icon: "ri-user-heart-line",
    title: "保持得的克制",
    desc: "只聚合讨论本身，不对未经证实的信息作结论性传播，理性围观、不信谣不带节奏。",
  },
  {
    icon: "ri-quill-pen-line",
    title: "可持续的更新",
    desc: "持续追踪新话题与新进展，把热点从「一阵风」沉淀为可检索的观点资产。",
  },
];

export const milestones: string[] = [
  "我们相信：评论区的争吵里藏着真实的大众情绪。",
  "我们相信：看得懂大家怎么想，比一味转发更重要。",
  "我们相信：客观地呈现多方声音，本身就是在守护讨论的善意。",
];